export enum StepsStep {
  APPOINTMENT_TYPE,
  INSURANCE,
  SCHEDULE_EXAM,
  PATIENT_DETAILS,
  CUSTOM_PAGE,
  CONTACT_DETAILS,
  TYP,
}
